<template>
  <div>
    <button @click="getData">获取</button>
    <Discount></Discount>
  </div>
</template>

<script>
import Discount from '@/components/discount.vue'
export default {
  data () {
    return {

    }
  },
  components: {
    Discount
  },
  methods: {
    getData () {
      this.addressBook()
    }
  }
}
</script>

<style scoped lang='less'>
</style>
